import config from 'config/env/all';
import {ROUTES} from './routes';
import METADATA from './metadata';

const VERSION = '1.0.0';

export {VERSION};

const currentEnvironment = "production";

const API_SETTINGS = {
  API_HOST: config.apiUrl || 'http://localhost:1340',
};

const CACHE_LIFETIME = {
  duration: 14,
  units: 'days',
};

export default function ConfigStorage() {
  return {
    ROUTES,
    METADATA,
    API_SETTINGS,
    CACHE_LIFETIME,
  };
}
